import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import type { Grupo, GruposState } from '@/types/grupo/grupoTypes';

import {
  criarGrupo,
  desvincularEscritorio,
  fetchConsolidado,
  fetchGrupos,
  vincularEscritorio,
} from './actions';

const initialState: GruposState = {
  items: [],
  consolidado: null,
  loading: false,
  saving: false,
  error: null,
};

const upsert = (items: Grupo[], updated: Grupo): Grupo[] => {
  const existe = items.some((item) => item.id === updated.id);
  return existe
    ? items.map((item) => (item.id === updated.id ? updated : item))
    : [updated, ...items];
};

const gruposAdminSlice = createSlice({
  name: 'gruposAdmin',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGrupos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGrupos.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchGrupos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchConsolidado.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.consolidado = null;
      })
      .addCase(fetchConsolidado.fulfilled, (state, action) => {
        state.loading = false;
        state.consolidado = action.payload;
      })
      .addCase(fetchConsolidado.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addMatcher(
        isAnyOf(criarGrupo.pending, vincularEscritorio.pending, desvincularEscritorio.pending),
        (state) => {
          state.saving = true;
          state.error = null;
        },
      )
      .addMatcher(
        isAnyOf(
          criarGrupo.fulfilled,
          vincularEscritorio.fulfilled,
          desvincularEscritorio.fulfilled,
        ),
        (state, action) => {
          state.saving = false;
          state.items = upsert(state.items, action.payload);
        },
      )
      .addMatcher(
        isAnyOf(criarGrupo.rejected, vincularEscritorio.rejected, desvincularEscritorio.rejected),
        (state, action) => {
          state.saving = false;
          state.error = (action.payload as string) ?? 'Erro na operação';
        },
      );
  },
});

export const { clearError } = gruposAdminSlice.actions;
export default gruposAdminSlice.reducer;
